import React, { useRef, useEffect, useState } from 'react';
import { useScrollText } from '../../hooks/useScrollText';
import hum from '../../assets/images/hum.jpg';
import styles from './Message.module.css';
import { clearTextFromTags, hideNumber } from '../../helpers/titreHelper';
import { useGetParams } from '../../hooks/useGetParams';
import { iconsSources } from '../../helpers/icons';

import { AnimatePresence, motion } from 'framer-motion';

const Message = ({ className, message, currentState, titrTag }) => {
  const { msgFontSize, authorFontSize, withAvatar } = useGetParams();
  const [scrollTrigger, setScrollTrigger] = useState(false);
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const [q, setQ] = useState('');

  useEffect(() => {
    setQ(message.id);
  }, [message.id]);

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    scrollTrigger
  );

  useEffect(() => {
    setTimeout(
      () =>
        setScrollTrigger((val) => {
          return !val;
        }),
      2500
    );
  }, [message]);

  const onErrorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || hum;
  };

  const avatar = withAvatar
    ? message?.image && message?.image !== '1'
      ? message?.image
      : iconsSources[message?.channel]
    : iconsSources[message?.channel];

  return (
    <div className={styles.wrapper}>
      {message.author && (
        <div className={styles.avatar}>
          <AnimatePresence mode="wait">
            {q === message.id && (
              <motion.img
                key={message.id}
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.1, 1] }}
                transition={{ duration: 0.5, delay: 0.5, times: [0, 0.7, 1] }}
                exit={{
                  scale: 0,
                  transition: { duration: 0.4, delay: 0 },
                }}
                src={avatar}
                alt={message?.author}
                onError={onErrorHandler}
              />
            )}
          </AnimatePresence>
        </div>
      )}
      {message.id && (
        <AnimatePresence mode="wait">
          {q === message.id && (
            <motion.div
              key={message.id}
              initial={{ scale: 0, x: '-50vw' }}
              animate={{ scale: [0, 1.1, 1], x: ['-50vw', '2vw', '0vw'] }}
              transition={{ duration: 0.5, delay: 1, times: [0, 0.7, 1] }}
              exit={{
                scale: 0,
                x: '-50vw',
                transition: { duration: 0.4, delay: 0.4 },
              }}
              className={styles.wrapperContent}>
              <div
                className={styles.name}
                style={{
                  fontSize: `${authorFontSize}rem`,
                }}>
                {message?.author || hideNumber(message?.senderNumber)}
              </div>
              <div className={styles.content}>
                <div className={styles.textWrapper} ref={contentContainerRef}>
                  <div
                    className={styles.text}
                    ref={contentRef}
                    style={{ fontSize: `${msgFontSize}rem` }}>
                    {clearTextFromTags(message?.content)}
                  </div>
                </div>
              </div>
              <div className={styles.triangle}>
                <span>◥</span>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
};

export default Message;
